let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ggzT2")).then(() => parcelRequire('8cnF0'));